var DataAjaxCall = function(jsonURL) {
    var json = $.ajax({
        url: jsonURL,
        async: false,
        success: function(data) {
            return data;
        },
        error: function() {

            var content = '<div class="alert alert-info">' +
                'URL <strong>ni veljaven</strong>.' +
                '<br>Pričakovani JSON je:<br>[{ "meta": [{ ... }], "data": [{ ... }] }]' +
                '</div>' +
                '<div class="no-entries">' +
                '<i class="fa fa-info" aria-hidden="true"></i>' +
                'Graf ni mogoče izrisati.' +
                '</div>';

            $(".agen-data-graph").append(content);
            $(".agen-data-table").append(content);

            return data;
        }
    }).responseText;

    //console.log("Json is: ", json);
    return json;
}

exports.DataAjaxCall = DataAjaxCall;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataAjaxCall/DataAjaxCall.js
// module id = 6
// module chunks = 0